





















































































import { Component, Vue } from 'vue-property-decorator';
import { ISignUpFields, ICognitoSignUpFields } from '@/common/types';

// components
import Base from '@/components/Login/Base.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
// Services
import router from '../../router';
import Brand from '@/services/Brand';
import store from '@/store';
import AuthService from '@/services/Auth';
import { IForgotPasswordFields } from '@/common/types';

// validations
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';
import ProgressTrackerDesktop from './ProgressTracker.vue';

@Component({
	name: 'ForgotPassword',
	components: {
		TextField,
		Alert,
		Validation,
		SelectField,
		RadioField,
		Base,
		Welcome,
		Checkbox,
		ProgressTrackerDesktop,
	},
	validations: {
		form: {
			email: {
				email,
				required,
			},
		},
	},
})
export default class ForgotPassword extends Vue {
	private error: string | boolean;

	private loading: boolean;
	private isInvalid: boolean;
	private logger: any;
	private form: any;
	constructor() {
		super();

		this.isInvalid = false;

		this.form = {
			email: '',
		};
	}

	private isInValid() {
		return this.$v.$invalid;
	}

	private submit() {
		this.form.email = this.form.email.toLowerCase();
		this.error = false;
		this.isInvalid = false;
		this.loading = true;

		this.$v.$touch();
		if (this.$v.$invalid) {
			this.isInvalid = true;
			this.loading = false;
			window.scrollTo(0, 0);
			return;
		}
		this.$Amplify.Auth.forgotPassword(this.form.email)
			.then(() => {
				this.loading = false;

				this.$router.push({
					name: 'reset-password',
					params: {
						config: {
							email: this.form.email,
						},
					},
				});
			})
			.catch(e => {
				this.loading = false;
				this.setError(e);
				console.log( e );
				// SentryCaptureException(e);
			});
	}

	private signIn() {
		this.$router.push({
			name: 'login',
		});
	}

	private setError(e) {
		this.error = e.message || e;
		window.scrollTo(0, 0);
	}
}
